import React, { forwardRef, ReactNode } from 'react'

import { InputStyled } from './TextInput.styles'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: ReactNode
  wrapperClass?: string
}

const TextInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { children, wrapperClass } = props

  return (
    <InputStyled {...props} ref={ref} className={wrapperClass}>
      {children}
    </InputStyled>
  )
})

TextInput.displayName = 'TextInput'

export { TextInput }
